// Configuration de l'API
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';
export const API_KEY = process.env.REACT_APP_API_KEY || ''; 